module.exports = __webpack_public_path__ + "static/media/mechanic.015eb384.jpg";